<div class="access-links">
    <div class="data-list file-preview-link-holder">
        <ul *ngIf="content">
            <!-- ****************************** FILE  ******************************* -->
            <li class="file-preview-link">
                <div class="justify-content">
                    <div class="flex-start width-available" *ngIf="showContentPreview() || showDownload()">
                        <div class="justify-content flex-wrap">
                            <div class="flex-basis margin-right breif-hidden"> 
                                <div class="file-preview-box" *ngIf="showContentPreview()"> 
                                    <rl-content-preview class="content-preview" [content]="content" [render-text]="false" [view]="showViewerLink"  (onClick)="clickMenu($event)"></rl-content-preview>
                                </div>
                            </div>
                            <div class="flex-basis">
                                <h3 class="content-title oblique breif-hidden" *ngIf="content.amazonDisplayFileName">{{content.amazonDisplayFileName}}</h3>
                                <p class="breif-hidden" *ngIf="content.fileSize">
                                    <span class="semi-bold breif-hidden">{{'content.access.fileSizeBytes' | translate}}:</span> {{content.fileSize}}
                                </p>
                                <button *ngIf="showDownload()" (click)="download()" class="btn-link no-padding span-link-item margin-right-double" id="viewOnlinDownloadLinkBtn-{{$id}}" role="button" tabindex="0" rlStopPropagation>
                                    <span class="link-item-title">
                                        <span>
                                            <i class="fa fa-cloud-download" aria-hidden="true"></i>
                                            <span *ngIf="!hasBrowzineLink">{{'general.download' | translate}}</span>
                                            <span *ngIf="hasBrowzineLink">{{'citation.attachment' | translate}}</span>
                                            <span *ngIf="hidden" class="ColorOrange full-hidden"> ({{'general.hide' | translate}})</span>
                                        </span>
                                        <span *ngIf="content?.license?.type!='CCC' &&content?.license?.type!='BOLK'" class="location breif-hidden">({{content?.amazonFileKey?.substr(content?.amazonFileKey.lastIndexOf('.')+1)}})</span>
                                    </span>
                                </button>
                                <!-- ****************** VIEW PDF (READONLY)****************** -->
                                <button class="btn-link span-link-item no-padding margin-right-double full-hidden" *ngIf="showContentPreview() && showViewerLink" type="button" (click)="openInNewTab()" [rlAria]="'general.view' | translate" id="content-access-view" rlStopPropagation>
                                    <span class="link-item-title">
                                        <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
                                        {{'citation.availability.view.pdf' | translate}}
                                    </span>
                                    <span *ngIf="hidden" class="ColorOrange full-hidden">({{'general.hide' | translate}})</span>
                                </button>
                                <span class="location price-box" *ngIf="showStudentInstPays()">
                                    <span  *ngIf="!content.license.funded">
                                        {{'general.studentPays' | translate}} ${{content?.license.price}}
                                    </span>
                                    <span *ngIf="content.license.funded">
                                        {{'general.institutionPays' | translate}} ${{content?.license.price}}
                                    </span>
                                </span>
                             </div>
                        </div>
                    </div>
                    <div class="flex-start span-link" *ngIf="(studentView || student) && enablePayPerUse && showAddToCart()">
                        <button class="no-padding no-margin span-link-item" [ngClass]="!isItemInCart() ? 'btn-link' : 'btn-clear no-border'" id="addToCardBtn" role="button" tabindex="0" rlStopPropagation>
                            <span class="link-item-title">
                                <span (click)="manageCart()" *ngIf="!isItemInCart()"><i class="fa fa-plus" aria-hidden="true"></i> {{'general.ppu.addToCart' | translate}} &#36;{{content.license.price}}</span>
                                <span (click)="openShoppingCart()" *ngIf="isItemInCart()"><i class="fa fa-check" aria-hidden="true"></i> {{'general.ppu.itemInCart' | translate}}</span>
                            </span>
                        </button>
                    </div>
                    <div class="flex-end breif-hidden">
                        <div class="justify-content">
                            <div class="flex-start">
                                <div class="justify-content flex-wrap">
                                    <div class="flex-basis margin-right">
                                        <ng-container *ngIf="displayAnnottaionToggel()">
                                            <rl-toggle-button [id]="'TOGGLE'" *rlHierarchy="['OWNER','COLLABORATOR']" [active]="content.allowAnnotations" [stateLabels]="{on:'toolbar.toggle.publicAnnotations',off:'toolbar.toggle.publicAnnotations'}"  (onChange)="onChangeAnnotationToggle($event)"></rl-toggle-button>
                                        </ng-container>
                                        <!-- Link Hidden message -->
                                         <div class="medium-text margin-right" *ngIf="hidden">
                                            <span class="ColorOrange">{{'general.hide' | translate}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-end remove-link-box" *ngIf="content?.amazonFileKey!= undefined">
                                <div class="link-action-box">
                                    <rl-menu [actions]="actions" (onClick)="clickMenu($event)"></rl-menu>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</div>